export interface ErrorEntity {
    code: string;
    field: string | null;
}
